// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-menu[data-v-7b27b4b0]{height:calc(100vh - 160px)}", ""]);
// Exports
module.exports = exports;
